import { useEffect } from 'react'

import { createChain } from './chain'
import { AgentProvider, useAgent } from './context'

function DevHandle() {
  const { runtime, status } = useAgent()

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      return
    }

    window.__dndAgent = {
      execute: runtime.execute,
      applyOps: runtime.applyOps,
      applyBatches: runtime.applyBatches,
      chain: () => createChain(runtime.execute),
      outline: options => runtime.outline(options),
      state: options => runtime.state(options),
      changes: since => runtime.changes(since),
      getNode: (node, full) => runtime.getNode(node, full),
      screenshot: options => runtime.screenshot(options),
      setFocus: ref => runtime.setFocus(ref),
      status,
      runtime,
    }

    return () => {
      delete window.__dndAgent
    }
  }, [runtime, status])

  return null
}

export default function AgentBridge({ children }) {
  return <AgentProvider>
    <DevHandle />
    {children}
  </AgentProvider>
}
